import { productItem } from '../../common';
/**
 * 网点达到派件看板
 * @startDate
 * @endDate
 * @scanSite
 * @type
*/
export const SiteArriveQuery = (params) => {
  return [
    {
      // 网点列表
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['destinationSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      andFilters: [
        {key: 'scanType', value: '分拨装车'},
        {key: 'isDestinationCenter', value: '是'},
        {key: 'scanSite', value: params.scanSite},
      ]
    },
    // 产品类型
    ProductQuery(params.scanSite)
  ]
}

export const ProductQuery = (scanSite) => {
  const unload = [];
  productItem().forEach(item => {
    unload.push({
      dataSource: 'actual_load_unload_result',
      dimensions: ['destinationSite'],
      andFilters: [
        {key: 'productType', value: item},
        {key: 'scanType', value: '分拨装车'},
        {key: 'isDestinationCenter', value: '是'},
        {key: 'scanSite', value: scanSite},
      ]
    })
  })
  return unload;
}

export const ProductQuery2 = (scanSite, type, name) => {
  const unload = [];
  productItem().forEach(item => {
    unload.push({
      dataSource: 'actual_load_unload_result',
      dimensions: [type],
      andFilters: [
        {key: 'productType', value: item},
        {key: type, value: name},
        {key: 'scanType', value: '分拨装车'},
        {key: 'isDestinationCenter', value: '是'},
        {key: 'scanSite', value: scanSite},
      ]
    })
  })
  return unload;
}